import React from 'react'
import { connect } from 'react-redux'
import strings from './strings.json'
import ShapeDetails from '../../common/shape-details'

class DrawObjects extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      drawType: this.props.drawType
    }
  }

  render() {
    const { drawType } = this.state
    return (
      <div className='tools-content' style={{
        height: 'calc(100vh - 265px)',
        // overflowY: 'auto'
      }}>
        <div className='tools-header'>
          <p className='underline'
            style={{
              font: "normal normal normal 20px/25px Roboto",
              letterSpacing: 0,
              color: '#A49E9E',
            }}>Draw a New Object</p>
          <div style={{ display: 'flex', marginTop: '10px' }}>
            <div className='tools-draw-selection' style={{
              backgroundColor: drawType === 'line' ? '#589500' : '',
              backgroundImage: drawType === 'line' ? 'url(../../../../../../../../asset/Draw-Line_Thin_FFFFFF_mdpi.png)' :
                'url(../../../../../../../../asset/Draw-Line_Thin_589500_ldpi.png)',
              color: drawType === 'line' ? 'white' : ''
            }}
              onClick={() => {
                if (drawType !== 'line') {
                  this.setState({ drawType: 'line' })
                }
              }}><p style={{
                top: '60%',
                position: 'relative',
                font: "normal normal normal 15px/20px Roboto",
                letterSpacing: 0,
              }}>Line</p></div>
            <div className='tools-draw-selection' style={{
              backgroundColor: drawType === 'polygon' ? '#589500' : '',
              backgroundImage: drawType === 'polygon' ? 'url(../../../../../../../../asset/Draw-Shape_Thin_FFFFFF_mdpi.png)' :
                'url(../../../../../../../../asset/Draw-Shape_Thin_589500_ldpi.png)',
              color: drawType === 'polygon' ? 'white' : ''
            }}
              onClick={() => {
                if (drawType !== 'polygon') {
                  this.setState({ drawType: 'polygon' })
                }
              }}><p style={{
                top: '60%',
                position: 'relative',
                font: "normal normal normal 15px/20px Roboto",
                letterSpacing: 0,
              }}>Shape</p></div>
            <div className='tools-draw-selection' style={{
              backgroundColor: drawType === 'circle' ? '#589500' : '',
              backgroundImage: drawType === 'circle' ? 'url(../../../../../../../../asset/Draw-Circle_Thin_FFFFFF_mdpi.png)' :
                'url(../../../../../../../../asset/Draw-Circle_Thin_589500_ldpi.png)',
              color: drawType === 'circle' ? 'white' : ''
            }}
              onClick={() => {
                if (drawType !== 'circle') {
                  this.setState({ drawType: 'circle' })
                }
              }}><p style={{
                top: '60%',
                position: 'relative',
                font: "normal normal normal 15px/20px Roboto",
                letterSpacing: 0,
              }}>Circle</p></div>
          </div>
          <p style={{
            marginTop: '10px',
            textAlign: 'left',
            font: "normal normal normal 15px/20px Roboto",
            letterSpacing: 0,
            color: '#A49E9E',
          }}>{strings[drawType]}</p>
        </div>
        {['circle', 'polygon', 'line'].includes(drawType) && (
          <ShapeDetails key={drawType} type={drawType} />
        )}
      </div>
    )
  }
}

const mapStateToProps = state => ({

})

const mapDispatchToProps = dispatch => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(DrawObjects)